var React = require('react');

function IconSquare (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"fill":"#F9F9F8","fillRule":"nonzero","width":"32","height":"32","key":0}),React.createElement("path",{"d":"M31,1 L1,1 L1,31 L31,31 L31,1 Z M0,0 L0,32 L32,32 L32,0 L0,0 Z","fill":"#7D7971","key":1})]));
}

IconSquare.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IconSquare;

IconSquare.default = IconSquare;
